const normalizePath = (href) => {
  try {
    const url = new URL(href, window.location.origin);
    let path = url.pathname.replace(/\/+$/, '');
    return path || '/';
  } catch {
    return '';
  }
};

const normalizeMenuTitle = (title) => title.trim().replace(/\s+/g, ' ').toLowerCase();

const canonicalMenuTitle = (title) => {
  const key = normalizeMenuTitle(title);
  if (key === 'about us' || key === 'about' || key === 'our story') return 'Our Story';
  if (key === 'track order' || key === 'track your order' || key === 'order tracking') return 'Track Your Order';
  if (key === 'shop' || key === 'shop caps') return 'Shop Caps';
  return title.trim().replace(/\s+/g, ' ');
};

const handleParentMenuClick = (event) => {
  const link = event.target.closest('.menu-list__link[href="#"]');
  if (!link) return;

  const listItem = link.closest('.menu-list__list-item');
  const disclosure = listItem?.querySelector('.menu-list__disclosure');
  if (!disclosure) return;

  event.preventDefault();
  disclosure.click();
};

const cleanHeaderMenu = () => {
  const menus = document.querySelectorAll('#header-component .menu-list__list, #header-component .overflow-menu');

  menus.forEach((menu) => {
    const seenTitles = new Set();
    const items = [...menu.querySelectorAll(':scope > li.menu-list__list-item, :scope > li')];

    items.forEach((item) => {
      if (item.hasAttribute('slot')) return;
      const link = item.querySelector(':scope > a, :scope > .menu-list__trigger > a');
      if (!link) return;

      const titleNode = link.querySelector('.menu-list__link-title') || link;
      const canonical = canonicalMenuTitle(titleNode.textContent || link.textContent || '');
      const key = normalizeMenuTitle(canonical);

      // The reference header has no standalone Contact item.
      if (key === 'contact') {
        item.remove();
        return;
      }

      // Keep only one top-level instance of each destination label.
      if (seenTitles.has(key)) {
        item.remove();
        return;
      }
      seenTitles.add(key);

      if (titleNode && titleNode.childNodes.length === 1 && titleNode.firstChild?.nodeType === Node.TEXT_NODE) {
        titleNode.textContent = canonical;
      } else if (titleNode && canonical !== titleNode.textContent.trim()) {
        // Preserve inner markup when present, but normalize the visible text node when possible.
        const textNode = [...titleNode.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
        if (textNode) textNode.textContent = canonical;
      }
    });

    // Match the reference desktop order when these links exist in Shopify Navigation.
    const desiredOrder = ['home', 'shop caps', 'care essentials', 'our story', 'sizing guide', 'track your order'];
    const remaining = [...menu.querySelectorAll(':scope > li.menu-list__list-item, :scope > li')].filter(
      (item) => !item.hasAttribute('slot')
    );
    const itemByTitle = new Map();
    remaining.forEach((item) => {
      const link = item.querySelector(':scope > a, :scope > .menu-list__trigger > a');
      if (!link) return;
      const titleNode = link.querySelector('.menu-list__link-title') || link;
      itemByTitle.set(normalizeMenuTitle(canonicalMenuTitle(titleNode.textContent || link.textContent || '')), item);
    });
    desiredOrder.forEach((title) => {
      const item = itemByTitle.get(title);
      if (item) menu.appendChild(item);
    });
  });

  const currentPath = normalizePath(window.location.href);
  const links = document.querySelectorAll('#header-component .menu-list__link');
  links.forEach((link) => {
    const rawHref = (link.getAttribute('href') || '').trim();
    const href = normalizePath(rawHref);
    const isNavigable = rawHref !== '' && rawHref !== '#' && !rawHref.toLowerCase().startsWith('javascript:');
    const isCurrent = isNavigable && href === currentPath;
    link.classList.toggle('menu-list__link--beaumont-current', isCurrent);
    if (isCurrent) link.setAttribute('aria-current', 'page');
    else if (link.getAttribute('aria-current') === 'page' && href !== currentPath) link.removeAttribute('aria-current');
  });
};

document.addEventListener('click', handleParentMenuClick);
document.addEventListener('DOMContentLoaded', cleanHeaderMenu, { once: true });
document.addEventListener('shopify:section:load', cleanHeaderMenu);
